<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="EditTopic"
    title="Edit Topic"
    submit-name="Save changes"
    full-height
    disable-tabindex
    :submit-disabled="dataError"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="currentLandscape && !dataError">
      <div class="flex flex-col mb-8 md:flex-row md:items-center">
        <lm-actor-select
          ref="actorSelect"
          class="mb0-important"
          :selected-actor="actor"
        >
          Move topic to:
        </lm-actor-select>
        <lm-checkbox
          v-model="priority"
          label="Important"
          class="mt-8 md:ml-8 md:mt-0"
          form-style
        />
        <important-help />
      </div>
      <lm-input
        ref="inputTitle"
        label="Title"
        :maxlength="0"
        focus
        @submit="submitFromInput"
      />
      <lm-editor
        ref="inputEditor"
        v-model="text"
        class="mb-8"
        :optional="false"
        @submit="submitFromInput"
      />
      <lm-tags-selector
        ref="tagSelector"
        :options="currentLandscape.tags"
        :tags="tags"
        class="mb-8"
        :required="requiredTagsTopic"
      />
      <lm-actor-selector
        ref="actorSelector"
        :actors="relatedActors"
        class="mb-8"
      />
    </template>
  </form-modal>
</template>

<script>
import LmCheckbox from '@/components/form/LmCheckbox'
import ImportantHelp from '@/components/modals/Topic/ImportantHelp'
import {mapGetters} from 'vuex'
import {imgInHTMLResize} from './Topic/resizeImagesInHTML'
import {Events, Modal} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmInput from '@/components/form/LmInput.vue'
import FormHelper from '@/components/form/formHelper'
import LmTagsSelector from '@/components/form/LmTagsSelector'
import LmEditor from '@/components/form/LmEditor'
import LmActorSelect from '@/components/form/LmActorSelect'
import LmActorSelector from '@/components/form/LmActorSelector'

export default {
  name: 'ModalEditTopic',
  components: {
    ImportantHelp,
    LmCheckbox,
    LmActorSelector,
    LmActorSelect,
    LmEditor,
    LmTagsSelector,
    FormModal,
    LmInput
  },
  data() {
    return {
      Events,
      modalName: Modal.EDIT_TOPIC,
      modalRef: null,
      inputs: null,
      text: '',
      picture: null,
      priority: false,
      tags: [],
      actor: null,
      relatedActors: null,
      bounds: '.EditTopic',
      inEditTopicId: null,
      dataError: false
    }
  },
  computed: {
    ...mapGetters(['currentLandscape', 'currentTopic', 'getActorByID']),
    ...mapGetters({
      requiredTagsTopic: 'preferences/requiredTagsTopic'
    })
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [
      this.$refs.inputTitle,
      this.$refs.inputEditor,
      this.$refs.tagSelector,
      this.$refs.actorSelect,
      this.$refs.actorSelector
    ]
    this.init()
  },
  methods: {
    init() {
      if (this.currentTopic && this.inEditTopicId !== this.currentTopic._id) {
        this.inEditTopicId = this.currentTopic._id
        FormHelper.clearErrors(this.inputs)
        this.updateInputData()
      } else {
        this.dataError = true
      }
    },
    updateInputData() {
      this.$refs.inputTitle.data = this.currentTopic.title
      this.actor = this.getActorByID(this.currentTopic.actorId)
      this.relatedActors = this.currentTopic.relatedActors
      this.tags = this.currentTopic.tags
      this.text = this.currentTopic.text
      this.priority = this.currentTopic.priority
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        imgInHTMLResize(this.text).then(resizedImgsText => {
          // Call API
          let payload = {
            title: this.$refs.inputTitle.data,
            text: resizedImgsText,
            priority: this.priority,
            tags: this.$refs.tagSelector.data,
            actorId: this.$refs.actorSelect.data,
            relatedActors: this.$refs.actorSelector.data,
            mentions: FormHelper.getEditorMentions()
          }
          this.$store
            .dispatch('editTopic', payload)
            .then(() => this.modalRef.submitSuccess())
            .catch(error => this.modalRef.submitFails(error))
        })
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, 'Topic updated')
      }
    }
  }
}
</script>
